import React ,{ lazy } from 'react';
import GaugeChart from 'globalcomponents/UI/Graph/GaugeChart/Base';
import { Divider } from '@material-ui/core';


const layout = window?.$environment?.CURRENT_LAYOUT;
const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));
const FleetScore = lazy(() => import(`../../FleetScoreInfo`));
const RangeInfo = lazy(() => import(`../../RangeInfo`));
const Label = lazy(() => import(`globalcomponents/UI/Label/${layout}`));


export const FleetScoreUI = ({ guageScore, scoreCard }) => {
    return (<div className="grid-item">
        <SubHeader
            variant="h1"
            className="statsHeading"
            text="Fleet Score"
        />
        <div className="fleet-score-graph3">
            <div className="div60">
                <GaugeChart value={guageScore} textClassName="totalScore" />
            </div>
            <div className="div40">
                <RangeInfo fleetScore />
            </div>
        </div>
        <div
            style={{
                width: '62%',
                textAlign: 'center',
                marginLeft: '5%',
            }}
        >
            <Label className="label" variant="h1">
                {scoreCard?.fleetScore}
            </Label>
        </div>
        <Divider className="divider-style" />
        <FleetScore scoreCard={scoreCard} />
    </div>)
}